import React, { useEffect, useState } from "react";
import ExportApi from "../../api/ExportApi";

const Shipmentapilogs = () => {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await ExportApi.getshipmentrateslogs(page, limit);
      const data = res?.data?.data || [];
      const pagination = res?.data?.pagination || { totalPages: 1 };

      // Step 1: Group by minute
      const groupedCounts = {};
      data.forEach((log) => {
        const createdAt = new Date(log.createdAt);
        const key = createdAt.toLocaleDateString() + " " + createdAt.getHours() + ":" + createdAt.getMinutes(); // e.g., "7/3/2025 14:04"
        groupedCounts[key] = (groupedCounts[key] || 0) + 1;
      });

      // Step 2: Attach count to each log
      const logsWithCount = data.map((log) => {
        const createdAt = new Date(log.createdAt);
        const key = createdAt.toLocaleDateString() + " " + createdAt.getHours() + ":" + createdAt.getMinutes();
        return { ...log, hitsInMinute: groupedCounts[key] };
      });

      setLogs(logsWithCount);
      setTotalPages(pagination.totalPages);
    } catch (err) {
      console.error("❌ Error fetching shipment rate logs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [page]);

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Shipping Rate Logs</h2>

      {loading ? (
        <p>Loading...</p>
      ) : logs.length === 0 ? (
        <p>No logs found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 text-sm">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="py-2 px-4 border">#</th>
                <th className="py-2 px-4 border">User Email Id</th>
                <th className="py-2 px-4 border">Amount</th>
                <th className="py-2 px-4 border">Provider</th>
                <th className="py-2 px-4 border">Service Level</th>
                <th className="py-2 px-4 border">Timestamp</th>
                <th className="py-2 px-4 border">Time</th>
                <th className="py-2 px-4 border">Hits in Minute</th> {/* ✅ New Column */}
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => {
                const createdAt = new Date(log.createdAt);
                return (
                  <tr key={log._id} className="text-center">
                    <td className="py-2 px-4 border">{(page - 1) * limit + index + 1}</td>
                    <td className="py-2 px-4 border">{log?.toUserId?.email}</td>
                    <td className="py-2 px-4 border">${log.amount?.toFixed(2)}</td>
                    <td className="py-2 px-4 border">{log.provider}</td>
                    <td className="py-2 px-4 border">{log.servicelevel}</td>
                    <td className="py-2 px-4 border">{createdAt.toLocaleString()}</td>
                    <td className="py-2 px-4 border">{createdAt.toLocaleTimeString()}</td>
                    <td className="py-2 px-4 border">{log.hitsInMinute}</td> {/* ✅ New data */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

   
    {/* Pagination Controls */}
<div className="w-full mt-4 flex justify-center">
  <div className="flex items-center gap-4 text-sm">
    <button
      className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
      onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
      disabled={page === 1}
    >
      Previous
    </button>
    <span>
      Page <strong>{page}</strong> of <strong>{totalPages}</strong>
    </span>
    <button
      className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
      onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={page === totalPages}
    >
      Next
    </button>
  </div>
</div>


    </div>
  );
};

export default Shipmentapilogs;
